<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-5"><a id="_idTextAnchor006"></a>Numbered Letters</h1>
<p class="Verse-first">R</p>
<p class="Verse-main">I</p>
<p class="Verse-main">P</p>
<p class="Verse-main">Letters on the news</p>
<p class="Verse-main">Political verbiage</p>
<p class="Verse-main">The meaning’s obtuse</p>
<p class="Verse-new">1.0 to 50,000</p>
<p class="Verse-main">Not just numbers or statistics</p>
<p class="Verse-main">Every number had a dream</p>
<p class="Verse-main">Unmasked faces makes me silently scream</p>
<p class="Verse-new">P.P.E.</p>
<p class="Verse-main">Means to me?</p>
<p class="Verse-main">Protection? Sure</p>
<p class="Verse-main">But more marks across my face</p>
<p class="Verse-main">And a nose so very sore</p>
<p class="Verse-new">And while we drown in an avalanche of facts</p>
<p class="Verse-main">The milk of human kindness tastes sour</p>
<p class="Verse-main">The outlook dour</p>
<p class="Verse-main">I only hope we can recover</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398433502_EPUB9.vue?640a7c04